<main>
	<section class="hero">
		<div class="hero-copy">
			<h1>Put your Lovable app <em>InMotion</em>.</h1>
			<p class="hero-lede">
				InMotion App Launcher turns your GitHub repo into a secure hosted
				app in minutes, no deployment expertise required.
			</p>
			<div class="trust-row" aria-label="App Launcher benefits">
				<span>GitHub-based source connection</span>
				<span>AI-assisted packaging</span>
				<span>Secure inmotion.hosting URL</span>
			</div>
		</div>

		<form class="start-card" (ngSubmit)="start()">
			<div class="start-card-header">
				<span class="status-badge">Free Labs preview</span>
				<span class="status-badge">No credit card required</span>
			</div>
			<h2>Get started now</h2>
			<p class="form-note">
				Create your preview account, then connect the GitHub repository
				for your Lovable-built app.
			</p>
			<div class="field">
				<label for="startEmail">Email address</label>
				<input
					id="startEmail"
					name="email"
					type="email"
					[(ngModel)]="email"
				/>
			</div>
			<button class="primary-button wide" type="submit">Continue</button>
			<p class="legal-note">
				By clicking <strong>CONTINUE</strong>, you are agreeing to try
				App Launcher and agree to abide by InMotion's applicable
				<a
					href="https://www.inmotionhosting.com/legal/universal-terms-of-service/?utm_source=direct&utm_medium=direct"
					target="_blank"
					rel="noreferrer"
					>Universal Terms of Service</a
				>
				and
				<a
					href="https://www.inmotionhosting.com/legal/privacy-policy/?utm_source=direct&utm_medium=direct"
					target="_blank"
					rel="noreferrer"
					>Privacy Policy</a
				>.
			</p>
			<p class="form-note">
				You can create a password on the next screen or continue with
				Google.
			</p>
		</form>
	</section>

	<section class="pilot-band" id="how-it-works">
		<div>
			<h2 class="pilot-flow-heading">Lovable to GitHub to InMotion.</h2>
		</div>
		<div class="flow-mini" aria-label="Pilot deployment flow">
			<article>
				<span>1</span><strong>Lovable project</strong>
				<p>Build your app in Lovable.</p>
			</article>
			<article>
				<span>2</span><strong>GitHub repository</strong>
				<p>Connect source and branch.</p>
			</article>
			<article>
				<span>3</span><strong>App Launcher</strong>
				<p>Click once and App Launcher handles the launch.</p>
			</article>
			<article>
				<span>4</span><strong>You're live</strong>
				<p>Boom. Your app is published on a secure InMotion URL.</p>
			</article>
		</div>
	</section>

	<section class="section split-section" id="why-app-deployment">
		<div>
			<h2>Built to remove the deployment gap after AI app creation.</h2>
			<p>
				Lovable makes it easier to create an application. This beta
				focuses on what happens next: connecting the project, preparing
				it for hosting, deploying it securely, and giving users
				visibility into health, logs, access, and notifications.
			</p>
		</div>
		<div class="benefit-list">
			<article>
				<h3>Connect source</h3>
				<p>
					Choose a GitHub repository and branch connected to the
					Lovable project.
				</p>
			</article>
			<article>
				<h3>Deploy with guidance</h3>
				<p>
					The beta retrieves, validates, scans, packages, and launches
					the app.
				</p>
			</article>
			<article>
				<h3>Monitor launch health</h3>
				<p>
					View status, deployment history, and live operational
					signals.
				</p>
			</article>
			<article>
				<h3>Get notified</h3>
				<p>
					Configure email or Slack alerts for deployment events during
					the pilot.
				</p>
			</article>
		</div>
	</section>

	<section class="labs-context">
		<article>
			<h2>Why InMotion Labs?</h2>
			<p>
				InMotion Labs is where we bring promising product ideas to
				customers early, learn from real usage, and shape the experience
				before broader release.
			</p>
		</article>
		<article>
			<h2>Why InMotion Hosting?</h2>
			<p>
				App Launcher pairs a Lovable-built app with InMotion's hosting
				experience: infrastructure, security-minded deployment, and
				support when a prototype needs to become a real hosted
				application.
			</p>
		</article>
	</section>

	<section class="section" id="product-screens">
		<div class="section-heading">
			<h2 class="one-line-heading">Your GitHub repo, live in minutes.</h2>
		</div>
		<div class="journey-grid">
			<article class="journey-card" *ngFor="let card of experienceCards">
				<div
					class="journey-graphic"
					[ngClass]="card.tone"
					aria-hidden="true"
				>
					<span>{{ card.icon }}</span>
					<i></i>
				</div>
				<h3>{{ card.title }}</h3>
				<p>{{ card.copy }}</p>
			</article>
		</div>
	</section>

	<section class="free-preview" id="free-preview">
		<div>
			<h2>Start with one active deployment.</h2>
			<p>
				Try App Launcher with a secure hosted URL and a guided path from
				repository connection to live application.
			</p>
		</div>
		<button
			class="primary-button light"
			type="button"
			(click)="startAppLauncher()"
		>
			Start the beta
		</button>
	</section>

	<sd-footer></sd-footer>
</main>
